export * from './lib/shared-ui-search-card.module';
export * from './lib/search-card.component';
